import { createFileRoute, Outlet } from '@tanstack/react-router';
import { List } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/risk/register')({
    staticData: {
        breadcrumb: {
            title: 'Risk register',
        },
        ui: {
            icon: List,
        },
    },
    component: Outlet,
});
